/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * 曜日を表現する列挙型クラスです。
 */
export enum DayOfWeek {
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
  SUNDAY = "sunday"
}
